import { FC, ReactNode } from 'react'
import cn from 'classnames'
import * as styles from 'components/features/pfm/Blocks/Blocks.css'
import newStyles from 'components/features/pfm/Blocks/Blocks.styl'
import { MISSING_TIMEFRAME_DATA_MESSAGE } from 'constants/errors'
import { BlockCorners, ShadowTheme } from 'interfaces/component'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { blockCornersSelector } from 'selectors/globalSelectors'
import Button from 'components/features/pfm/Button/Button'
import { Omit } from 'interfaces'

type CardBlockStateProps = {
  corners: BlockCorners
}

export type CardBlockOwnProps = {
  isExpanded?: boolean
  shadowTheme?: ShadowTheme
  withPadding?: boolean
  fullHeight?: boolean
  corners?: BlockCorners
  forceRoundedCorners?: boolean
  noBorders?: boolean
  className?: string
}

type CardBlockProps = CardBlockStateProps & CardBlockOwnProps

const CardBlockComponent: FC<CardBlockProps> = (props) => {
  const { children, isExpanded, shadowTheme, withPadding, fullHeight, corners, className, forceRoundedCorners, noBorders } = props

  const rootClassName = cn(styles.cardBlock, {
    [styles.expanded]: isExpanded,
    [styles.withPadding]: withPadding,
    [styles.fullHeight]: fullHeight,
    [styles.noShadow]: shadowTheme === 'no-shadow',
    [styles.withShadow]: shadowTheme === 'regular',
    [styles.mediumShadow]: shadowTheme === 'medium',
    [styles.softShadow]: shadowTheme === 'soft',
    [styles.bottomCorners]: corners === 'bottom',
    [styles.topCorners]: corners === 'top',
    [styles.allCorners]: corners === 'all',
    [styles.forceRoundedCorners]: forceRoundedCorners,
    [styles.noBorders]: noBorders,
  })

  return (
    <div className={ cn(rootClassName, className) }>
      { children }
    </div>
  )
}

const mapStateToProps = createSelector(
  blockCornersSelector,
  (corners) => ({ corners })
)
export const CardBlock = connect<CardBlockStateProps, {}, CardBlockOwnProps>(mapStateToProps)(CardBlockComponent)

export const EmptyCardBlock: FC<CardBlockOwnProps> = ({ children, corners, shadowTheme, className, forceRoundedCorners }) => (
  <CardBlock
    withPadding
    forceRoundedCorners={ forceRoundedCorners }
    corners={ corners }
    shadowTheme={ shadowTheme }
    className={ className }
  >
    <div className={ styles.notification }>
      <div className={ styles.notificationInner }>
        { children || MISSING_TIMEFRAME_DATA_MESSAGE }
      </div>
    </div>
  </CardBlock>
)

type EmptyCardBlockWithCtaProps =
  & Omit<CardBlockOwnProps, 'shadowTheme'>
  & {
    text: ReactNode
  }
  & (
    | {
      buttonText: ReactNode
      onClick: () => void
    }
    | {
      button: ReactNode
    }
  )
export const EmptyCardBlockWithCta: FC<EmptyCardBlockWithCtaProps> = (props) => {
  const {
    text,
    forceRoundedCorners, corners, className,
  } = props

  const buttonChild = 'button' in props
    ? props.button
    : (
      <Button style='hollow' fullWidth fullHeight onClick={ props.onClick }>
        { props.buttonText }
      </Button>
    )

  return (
    <CardBlock
      withPadding={ false }
      forceRoundedCorners={ forceRoundedCorners }
      corners={ corners }
      shadowTheme='no-shadow'
      className={ className }
    >
      <div className={ styles.notification }>
        <div className={ styles.notificationInner }>
          <p className={ newStyles.emptyCopy }>
            { text }
          </p>
          <div className={ newStyles.emptyCta }>
            { buttonChild }
          </div>
        </div>
      </div>
    </CardBlock>
  )
}
